//
//
//
//
//
//

var path = process.env.VUE_APP_BASE_PATH;
export default {
  name: 'FormGenerator',
  data: function data() {
    return {
      basePath: path
    };
  }
};